import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad11FBlue11ARed = () => <CrossRoad coords="2111.000000, 544.000000" />;

export default CrossRoad11FBlue11ARed;
